<template>
  <transition name="p-snackbar-transition" mode="out-in">
    <template v-if="snackbarList?.length && onNext">
      <p-snackbar :message="snackbarList[0]" @on-next="nextSnackbar()" />
    </template>
  </transition>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useSnackbarStore } from '@/store/snackbar'

const snackbarStore = useSnackbarStore()
const snackbarList = computed(() => snackbarStore.getSnackbarList) || []

const onNext = ref(true)

const nextSnackbar = () => {
  onNext.value = false
  setTimeout(() => (onNext.value = true))
}
</script>

<style scoped>
.p-snackbar-transition-enter-active,
.p-snackbar-transition-leave-active {
  transition: opacity 0.3s ease;
}

.p-snackbar-transition-enter-from,
.p-snackbar-transition-leave-to {
  opacity: 0;
}
</style>
